import {
	SPACE_OVERVIEW,
	PAGE_DIFF_BY_VERSION,
} from '@confluence/named-routes/entry-points/routes.ts';
import { CONTEXT_PATH } from '@confluence/named-routes/entry-points/context.ts';

import type { FeedEventType } from '../__generated__/useFollowingFeedWithSortByStorageFeedContentQuery.graphql.ts';
import type { CommentField, SummaryLineUpdate } from '../feedCardTypes.ts';

// Create a flexible content type that can handle various content structures from Following and Popular feeds
type ContentLike = {
	readonly links?: {
		readonly webui?: string | null;
	} | null;
	readonly space?: {
		readonly key?: string | null;
		readonly alias?: string | null;
	} | null;
} | null;

type SummaryLineUpdate_Edit = SummaryLineUpdate & {
	readonly type: 'EDIT';
	readonly version: number;
};
type SummaryLineUpdate_Comment = SummaryLineUpdate & {
	readonly type: 'COMMENT';
	readonly comment: CommentField;
};

export const getContentLink = (content?: ContentLike | null): string => {
	if (!content?.links?.webui) {
		return '';
	}
	return `${CONTEXT_PATH}${content.links.webui}`;
};

export const getCommentLink = (comment: CommentField): string => {
	if (!comment?.links?.webui) {
		return '';
	}
	return `${CONTEXT_PATH}${comment.links.webui}`;
};

export const getSpaceLink = (content?: ContentLike | null): string => {
	const spaceKey = content?.space?.key;
	if (!spaceKey) {
		return '';
	}

	const spaceAlias = content?.space?.alias || spaceKey;

	return SPACE_OVERVIEW.toUrl({ spaceKey: spaceAlias });
};

type User = {
	accountId: string | null;
};
export const getUserAccountId = (user?: User | {} | null): string | null => {
	if (user) {
		return 'accountId' in user ? user.accountId : null;
	}
	return null;
};

export const getLinkForSummaryLinkUpdate = (
	update: SummaryLineUpdate,
	contentUrl: string,
	contentId: string,
): string => {
	const type = update.type;
	if (type === 'COMMENT') {
		const commentLink = (update as SummaryLineUpdate_Comment).comment?.links.webui;
		if (commentLink) {
			return `${CONTEXT_PATH}${commentLink}`;
		} else {
			return '';
		}
	}

	if (type === 'CREATE' || type === 'EDITLIVE' || type === 'PUBLISHLIVE') {
		return contentUrl;
	}

	if (type === 'EDIT') {
		const version = (update as SummaryLineUpdate_Edit).version;
		const params = {
			query: {
				pageId: contentId,
				selectedPageVersions: [version, version - 1],
			},
		};
		return PAGE_DIFF_BY_VERSION.toUrl({}, params);
	}

	return '';
};

const supportedEventTypes: FeedEventType[] = [
	'COMMENT',
	'CREATE',
	'EDIT',
	'EDITLIVE',
	'PUBLISHLIVE',
];
export const isSupportedEvent = (type: FeedEventType): boolean => {
	return supportedEventTypes.includes(type);
};
